export default theme => ({
  container: {
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'center'
  },
  warningText: {
    color: theme.palette.secondary.main + ' !important'
  }
});
